import axios from 'axios'

const wechat = {}
// 查询自定义菜单
wechat.find = params => { return axios.post('/wechatMenu/find', params)}
// 加载自定义菜单
wechat.load = params => { return axios.get('/wechatMenu/load', {params})}
// 保存/修改自定义菜单
wechat.save = params => { return axios.post('/wechatMenu/update', params)}
// 删除自定义菜单
wechat.del = params => { return axios.get('/wechatMenu/delete', {params})}
// 更新自定义菜单
wechat.updateMenu = params => { return axios.get('/weChat/addMenu', {params})}
export default wechat



// WEBPACK FOOTER //
// ./src/api/wechat.js